// src/components/common/StarRating.jsx

import React from 'react';
import { FaStar, FaStarHalfAlt, FaRegStar } from 'react-icons/fa';
import PropTypes from 'prop-types';
import styles from './StarRating.module.css';

const StarRating = ({ 
  rating = 0, 
  maxRating = 5, 
  size = 'medium',
  showNumber = false,
  className = ''
}) => {
  const getStars = () => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 >= 0.5;
    
    for (let i = 1; i <= maxRating; i++) {
      if (i <= fullStars) {
        stars.push(
          <FaStar key={i} className={styles.starFilled} />
        );
      } else if (i === fullStars + 1 && hasHalfStar) {
        stars.push(
          <FaStarHalfAlt key={i} className={styles.starHalf} />
        );
      } else {
        stars.push(
          <FaRegStar key={i} className={styles.starEmpty} />
        );
      }
    }
    
    return stars;
  };
  
  return (
    <div className={`${styles.starRating} ${styles[size]} ${className}`}>
      <div className={styles.stars}>{getStars()}</div>
      {showNumber && (
        <span className={styles.ratingNumber}>
          {rating.toFixed(1)}
        </span>
      )}
    </div>
  );
};

StarRating.propTypes = {
  rating: PropTypes.number,
  maxRating: PropTypes.number,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  showNumber: PropTypes.bool,
  className: PropTypes.string
};

export default StarRating;

